'use client';
import {createAppKit} from '@reown/appkit';
import {
  cookieStorage,
  cookieToInitialState,
  createStorage,
  WagmiProvider,
  type Config,
} from 'wagmi';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {WagmiAdapter} from '@reown/appkit-adapter-wagmi';
import {ReactNode} from 'react';
import {mainnet, arbitrum} from 'viem/chains';
import {projectId} from './config';

const queryClient = new QueryClient();
const networks = [mainnet, arbitrum];

export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
  networks,
  projectId,
});

export const config = wagmiAdapter.wagmiConfig;

createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks: [mainnet, arbitrum],
  defaultNetwork: mainnet,
  features: {
    analytics: true,
    email: false,
    socials: ['google'],
    emailShowWallets: true,
    // collapseWallets:true,
  },
  themeMode: 'dark',
  themeVariables: {},
});

function AppKitProvider({
  children,
  cookies,
}: {
  children: ReactNode;
  cookies: string | null;
}) {
  const initialState = cookieToInitialState(
    wagmiAdapter.wagmiConfig as Config,
    cookies,
  );
  return (
    <WagmiProvider
      config={wagmiAdapter.wagmiConfig as Config}
      initialState={initialState}
    >
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
export default AppKitProvider;
